import { useNavigate, useLocation } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import SbuForm from '../components/forms/SbuForm';
import SbuTable from '../components/SbuTable';

const SbuModel = () => {
     const navigate = useNavigate();
     const location = useLocation();

     const showModal = location.pathname === '/sbu/add';

     const handleCloseModal = () => {
          navigate('/sbu');
     };

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>SBU Master</h2>
                    <button className="add-employee-btn" onClick={() => navigate('/sbu/add')}>
                         Add SBU
                    </button>
               </div>
               <SbuTable />
               <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
                    <Modal.Header closeButton>
                         <Modal.Title>Add New SBU</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <SbuForm />
                    </Modal.Body>
               </Modal>
          </div>
     );
};

export default SbuModel;